import { useSessionWithUser } from "src/components/session/session";
import { useIsFeatureEnabled } from "src/hooks/useIsFeatureEnabled";
import { useListUserMembershipsQuery } from "src/gql/codegen/graphql";
import { useEffect, useState } from "react";
import { httpFetch } from "src/utils/http/http";
import { ShowStatus } from "../types";
import { CreateTeamPromptBannerProps } from "./CreateTeamPromptBanner";
import {
  tryLocalStorageGetItem,
  tryLocalStorageSetItem,
} from "src/utils/storage/storage";

export const useShouldShowCreateTeamPromptBanner = (): [
  ShowStatus,
  CreateTeamPromptBannerProps | null,
] => {
  const session = useSessionWithUser();
  const isFlagEnabled = useIsFeatureEnabled("show_create_team_prompt_banner");
  const bannerId = "create_team_prompt_banner";
  const [isDismissed, setDismissed] = useState(
    tryLocalStorageGetItem(bannerId) === "dismissed"
  );

  const result = useListUserMembershipsQuery({
    skip: session?.user?.id === undefined,
    context: { session },
    variables: {
      user_id: session?.user?.id,
      user_email: session?.email,
    },
  });
  const [freeEmailProviderDomains, setFreeEmailProviderDomains] = useState<
    Set<string>
  >(new Set());
  useEffect(() => {
    httpFetch("/assets/free_email_provider_domains.json").then((data) => {
      if (Array.isArray(data)) {
        setFreeEmailProviderDomains(new Set(data));
      }
    });
  }, []);

  if (result.loading || result.error !== undefined) {
    return ["loading", null];
  }
  if (session === undefined || !isFlagEnabled || isDismissed) {
    return ["dont-show", null];
  }
  const emailIsBusinessEmail = () => {
    const emailDomain = session?.email.split("@")[1];
    return !freeEmailProviderDomains.has(emailDomain);
  };
  const userHasNoTeams = () => {
    return (
      result.data !== null &&
      result.data !== undefined &&
      result.data.memberships_private_details.length === 0
    );
  };
  const userSignedUpMoreThan7DaysAgo = () => {
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000;
    return (
      Date.now() - new Date(session.user.created_at).valueOf() > sevenDaysInMs
    );
  };

  if (
    emailIsBusinessEmail() &&
    userHasNoTeams() &&
    userSignedUpMoreThan7DaysAgo()
  ) {
    return [
      "show",
      {
        userId: session.user.id,
        onDismiss: () => {
          tryLocalStorageSetItem(bannerId, "dismissed");
          setDismissed(true);
        },
      },
    ];
  }
  return ["dont-show", null];
};
